import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TransactionListPageComponent} from './transaction-list-page.component';
import {RouterModule} from '@angular/router';
import {CmsPageGuard} from '@spartacus/storefront';
import {AuthGuard} from '@spartacus/core';
import {FormsModule} from '@angular/forms';
import {SafePipeModule} from '@app/pipes/safeResourceUrl/safeResourceUrl.module';
import {IframeModule} from '@app/shared/iframe/iframe.module';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {CartEditModule} from '@app/cart/edit-cart/cart-edit.module';
import {LoadingPageModule} from '@dcp/configurator';
import '@udex/web-components/dist/Table.js';
import '@udex/web-components/dist/TableHeaderRow.js';
import '@udex/web-components/dist/TableHeaderCell.js';
import '@udex/web-components/dist/TableRow.js';
import '@udex/web-components/dist/TableCell.js';
import '@udex/web-components/dist/TableGroupRow.js';

@NgModule({
  declarations: [
    TransactionListPageComponent,
  ],
  imports: [
    CommonModule,
    SafePipeModule,
    RouterModule.forChild([{
      path: 'test/transactions',
      component: TransactionListPageComponent,
      canActivate: [CmsPageGuard, AuthGuard]
    }]),
    FormsModule,
    IframeModule,
    ClipboardModule,
    CartEditModule,
    LoadingPageModule,
  ],
  exports: [RouterModule],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class TransactionListPageModule {
}
